module.exports = __webpack_public_path__ + "9788f41e/img/question-icon.06c20c5d.svg";